import script from "./WithdrawApplication.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawApplication.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawApplication.vue?vue&type=style&index=0&id=2a55c9de&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src014250190/src/byggesoknaden-support-gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a55c9de"]])

export default __exports__